<template>
  <div id="instances-slim-list">
    <div v-if="!minimum">
      <vs-table
        search
        :sst="true"
        :data="instances"
        :max-items="itemsPerPage"
        @search="handleSearch"
        :noDataText="selectedTenants.length > 0 ? 'Sem dados disponíveis.' : 'Necessário selecionar no mínimo uma dash.'"
      >
        <template slot="header">
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" >
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">
              {{ page * itemsPerPage - (itemsPerPage - 1) }} -
              {{ instances.length - page * itemsPerPage > 0 ? page * itemsPerPage : instances.length }} de {{ totalItens }}
            </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage=4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </template>

        <template slot="thead">
          <vs-th style="width: 50px" v-if="checkbox"></vs-th>
          <vs-th sort-key="name">Nome</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <vs-checkbox v-model="selecteds" :vs-value="tr.id"/>
            </vs-td>
            <vs-td>
              <p>{{ tr.name }}</p>
            </vs-td>
          </vs-tr>
          </tbody>
        </template>
      </vs-table>

      <div class="mt-3 mr-4">
        <vs-pagination :total="totalPages" v-model="page"  @change="handleChangePage"  max="7" />
      </div>
    </div>
    <div v-else class="instance-filter-scroll">
      <VuePerfectScrollbar :key="$vs.rtl" :settings="settings">
        <div :key="indextr" v-for="(tr, indextr) in instances" class="flex mb-2">
          <vs-td>
            <vs-checkbox v-model="selecteds" :vs-value="tr.id" :title="tr.name">
              <div class="flex">
                <p class="align-self-center">{{ tr.name | truncate(20, true) }}</p>
              </div>
            </vs-checkbox>
          </vs-td>
        </div>
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import instance from "@/http/requests/instance";
import {mapGetters} from "vuex";

export default {
  components: { VuePerfectScrollbar },
  props: {
    checkbox: {
      type: Boolean,
      required: false
    },
    search: {
      type: Boolean,
      required: false,
      default(){ return false }
    },
    selecteds: {
      required: false,
      default(){ return [] },
      validator: prop => typeof prop === 'object' || prop === null
    },
    selectedTenants: {
      required: false,
      default(){ return [] },
      validator: prop => typeof prop === 'object' || prop === null
    },
    minimum: {
      type: Boolean,
      required: false,
      default(){ return false },
    },
  },
  data() {
    return {
      page: 1,
      totalItens: 0,
      totalPages: 0,
      instances: [],
      searchQuery: '',
      itemsPerPage: 4,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    ...mapGetters(['token'])
  },
  watch: {
    selecteds() {
      this.$emit("selectedGroup", this.selecteds);
    },
    itemsPerPage() {
      this.page = 1;
      this.fetch()
    },
    selectedTenants(value) {
      if (value.length > 0) {
        this.fetch();
      } else {
        this.clean();
      }
    }
  },
  methods: {
    handleSearch(searching) {
      this.page = 1;
      this.searchQuery = searching;
      this.fetch();
    },
    handleChangePage() {
      this.fetch();
    },
    clean() {
      this.page = 1;
      this.search = '';
      this.instances = [];
      this.itemsPerPage = 4;
      this.totalPages = 0;
      this.totalItens = 0;
    },
    async fetch() {
      if (this.selectedTenants.length === 0) {
        return;
      }

      const data = (await instance.fetch(
        this.token,
        this.selectedTenants,
        this.searchQuery,
        this.page,
        this.itemsPerPage
      ))['data'];

      this.instances = data['items'];
      this.totalPages = data['total_pages'];
      this.totalItens = data['total_items'];
    }
  },
  created() {
    this.clean();
    if (!this.instances.length) {
      this.fetch();
    }
  },
}
</script>

<style lang="scss">
.instance-filter-scroll {
  width: 100%;
  height: 8rem;
  margin: auto;
  overflow-y: auto;
  position: relative;
  max-height: 100px !important;
}
</style>
